import { useEffect, useRef, useState } from "react";

function fix_phone_value(new_value: string, sel_start: number, sel_end: number): [string, number, number] {
    var text = '+__ _________';
    var numbers = new_value.match(/\d/g)?.join('') || '';

    for (var numb of numbers)
    {
        var idx = text.indexOf('_');

        if (idx != -1)
        {
            text = text.substring(0, idx) + numb + text.substring(idx+1);
        }
    }

    if (sel_start !== null && sel_end !== null && text.charAt(sel_start-1) === ' ' && text.charAt(sel_start) !== '_')
    {
        sel_start++;
        sel_end++;
    }

    return [text, sel_start, sel_end];
}

export function PhoneNumberInput({ value, onChange, id }: { value: string, onChange: (phoneNumber: string) => void, id?: string })
{
    function onPhoneNumberChange(event: React.ChangeEvent<HTMLInputElement>) {
        let input = event.target as HTMLInputElement;

        let [text, sel_start, sel_end] = fix_phone_value(input.value, input.selectionStart || 0, input.selectionEnd || 0);

        input.value = text;
        input.selectionStart = sel_start;
        input.selectionEnd = sel_end;

        onChange(text);
    }

    return <input id={id} value={value} type="text" onChange={(e) => onPhoneNumberChange(e)} /> 
}
